<template>
	<v-flex xs12>
	<v-container fluid grid-list-md> 	
      <v-text-field
      :label="translater.__('Content', 'tasks')"
      v-model="content"
      ></v-text-field>
    </v-container>
    <v-container>
	    <v-textarea
          
          :label="translater.__('Description')"
          v-model="desc"
        ></v-textarea>
        <v-card-actions v-if="this.showButtons === true">
			        	<!--v-btn :disabled="!valid" @click="update()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Update')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="() => update()"></SuccessButton>
			        	<!--v-btn @click="edit = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => edit = false"></ErrorButton>

			        </v-card-actions>
    </v-container>

</v-flex>
</template>

<script>

	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'

	export default {
		name: 'EditTextTask',
		components: {ErrorButton, SuccessButton},
		props: ['showButtons', 'validateMethod'],

		methods: {
			update()
			{
				this.$store.dispatch('checkpoints/updateTask');
			}
		},

		computed: {
			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			content: {
				get()
				{
					return this.$store.getters['checkpoints/editableTask'].question.content
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setEditableTaskContent', value)

					this.$store.dispatch(this.validateMethod)
					.then((valid) => {

						this.$store.commit('checkpointsValidator/setValidEdit', valid)
					})
				}
			},

			desc:{
				get()
				{
					let d = this.$store.getters['checkpoints/editableTask'].question.description

					
					return d;
				},
				set(value)
				{
					this.$store.dispatch('checkpoints/setEditableTaskDescription', value)
					this.$store.dispatch(this.validateMethod)
					.then((valid) => {
						//console.log("valid!!", valid)
						this.$store.commit('checkpointsValidator/setValidEdit', valid)
					})
				}
			},

			edit: {
				get()
				{
					return this.$store.getters['checkpoints/ediTask'];
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setEditTask', value)
				}
			},

			valid: {
				get()
				{
					let v = this.$store.getters['checkpointsValidator/isValidEdit'];

					return v;
				}
			}
		}
	}


</script>